/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  loginId: string;
  isActive: boolean;
  agency?: {
    id: number;
    name: string;
  };
  developer?: {
    id: number;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
};

export type CreateParams = {
  id?: number;
  loginId?: string;
  password?: string;
  isActive?: boolean;
  agencyId?: number;
  developerId?: number;
};

export type UpdateParams = CreateParams;

export class Api {
  public static index() {
    return request.get<IndexResponse[]>("/admin/users");
  }

  public static create(params: CreateParams) {
    return request.post("/admin/users", params);
  }

  public static update(id: number, params: UpdateParams) {
    return request.post(`/admin/users/${id}`, params);
  }
}
